import script from "./MatriculasNovasAnual.vue?vue&type=script&setup=true&lang=js"
export * from "./MatriculasNovasAnual.vue?vue&type=script&setup=true&lang=js"

import "./MatriculasNovasAnual.vue?vue&type=style&index=0&id=8514ffe0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8514ffe0"]])

export default __exports__